import { z } from 'zod'

/**
 * The state of one proposal version.
 *
 * Like an invite's status, this has NO Prisma counterpart: it is derived from
 * the version's timestamps plus whether a later version has been sent, so a
 * stored column can never contradict the record. Precedence, highest first:
 *
 *   ACCEPTED   — `acceptedAt` set. Terminal, and stays so even past expiry.
 *   DECLINED   — `declinedAt` set.
 *   SUPERSEDED — sent, but a later version has since been sent. This is what
 *                answers "which version is the live one?".
 *   EXPIRED    — sent, `validUntil` has passed, nothing replaced it.
 *   SENT       — with the client, awaiting an answer.
 *   DRAFT      — never sent, still editable.
 */
export const PROPOSAL_VERSION_STATUSES = [
  'DRAFT',
  'SENT',
  'SUPERSEDED',
  'EXPIRED',
  'ACCEPTED',
  'DECLINED',
] as const

export const proposalVersionStatusSchema = z.enum(PROPOSAL_VERSION_STATUSES)

export type ProposalVersionStatus = z.infer<typeof proposalVersionStatusSchema>

export const PROPOSAL_VERSION_STATUS_LABELS: Record<
  ProposalVersionStatus,
  string
> = {
  DRAFT: 'Draft',
  SENT: 'Sent',
  SUPERSEDED: 'Superseded',
  EXPIRED: 'Expired',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
}
